import React from 'react';
import { Col, Row } from 'antd';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import SimCardForm from './SimCardForm';
import { useParams } from 'react-router-dom';

const AddSimCard = () => {
  const { id } = useParams();

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath="/dashboard"
          routeSegments={[
            { name: 'Quản lý SIM', path: '/sim-cards' },
            { name: id ? 'Cập nhật SIM' : 'Thêm mới SIM' }
          ]}
        />
      </div>
      <Row>
        <Col span={24}>
          <SimCardForm />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default AddSimCard;
